module.exports = " <div class=footer> Copyright @ 2014 Naersi.com ALL Rights Reserved. <a href=http://beian.miit.gov.cn>粤ICP备17014349号</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 59
// module chunks = 1